export const editResult = {
    NONE: 'none',
    SUCCESS: 'success',
    FAIL: 'fail'
}